<div class="ba-panel" *ngIf="row">
  <section class="ba-card">
    <div class="ba-card__header">
      <span class="ba-card__title"><mat-icon>account_balance</mat-icon> Datos de la cuenta</span>
      <button *ngIf="row.uid" mat-stroked-button class="cf-btn cf-btn--primary" (click)="edit.emit(row)">
        <mat-icon>edit</mat-icon> Editar
      </button>
    </div>

    <div class="ba-lines">
      <div class="ba-line">
        <span class="ba-line__label">Entidad</span>
        <span class="ba-line__value">{{ row.bank || '—' }}</span>
      </div>
      <div class="ba-line">
        <span class="ba-line__label">IBAN</span>
        <span class="ba-line__value ba-line__value--mono">{{ formattedIban || '—' }}</span>
      </div>
      <div class="ba-line">
        <span class="ba-line__label">BIC / SWIFT</span>
        <span class="ba-line__value ba-line__value--mono">{{ row.swift || '—' }}</span>
      </div>
      <div class="ba-line">
        <span class="ba-line__label">Cuenta contable</span>
        <span class="ba-line__value ba-line__value--mono">{{ row.accountNumber || '—' }}</span>
      </div>
    </div>

    <div class="ba-kpis">
      <div class="ba-kpi ba-kpi--accent">
        <span class="ba-kpi__label">Saldo contable</span>
        <span class="ba-kpi__value">{{ (row.saldoContable || 0) | number:'1.2-2' }} €</span>
      </div>
      <div class="ba-kpi">
        <span class="ba-kpi__label">Impuestos</span>
        <app-status-pill [label]="row.taxationDefault ? 'Sí' : 'No'" [variant]="row.taxationDefault ? 'success' : 'neutral'"></app-status-pill>
      </div>
      <div class="ba-kpi">
        <span class="ba-kpi__label">Domiciliación</span>
        <app-status-pill [label]="row.remesa ? 'Principal' : 'No'" [variant]="row.remesa ? 'success' : 'neutral'"></app-status-pill>
      </div>
      <div class="ba-kpi">
        <span class="ba-kpi__label">Conexión</span>
        <app-status-pill [label]="row.connected ? 'Conectada' : 'Sin conectar'" [variant]="row.connected ? 'info' : 'neutral'"></app-status-pill>
      </div>
    </div>
  </section>

  <section class="ba-card">
    <div class="ba-card__header">
      <span class="ba-card__title"><mat-icon>compare_arrows</mat-icon> Movimientos del ejercicio</span>
    </div>

    <app-loading-state *ngIf="loading" [compact]="true" message="Cargando movimientos…"></app-loading-state>

    <div class="ba-empty" *ngIf="!loading && !row.uid">
      <mat-icon>info</mat-icon>
      <span>Esta cuenta no tiene cuenta contable asociada.</span>
    </div>

    <div class="ba-empty ba-empty--error" *ngIf="!loading && error">
      <mat-icon>error</mat-icon>
      <span>No se pudieron cargar los movimientos.</span>
      <button mat-stroked-button class="cf-btn" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <ng-container *ngIf="!loading && !error && row.uid">
      <div class="ba-block" *ngFor="let block of blocks; trackBy: trackByBlock">
        <div class="ba-block__header">
          <span class="ba-block__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
          <span class="ba-block__side">
            <span class="ba-block__summary" *ngIf="block.count > 0">
              {{ block.count }} · <strong>{{ block.total | number:'1.2-2' }} €</strong>
            </span>
            <button mat-stroked-button type="button" class="cf-btn cf-btn--primary ba-add" (click)="add(block)">
              <mat-icon>add</mat-icon> Añadir
            </button>
          </span>
        </div>

        <div class="ba-moves" *ngIf="block.lines.length">
          <div class="ba-move" *ngFor="let line of block.lines; trackBy: trackByUid">
            <span class="ba-move__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
            <span class="ba-move__info">
              <span class="ba-move__concept" [title]="line.concept">{{ line.concept }}</span>
              <span class="ba-move__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
            </span>
            <span class="ba-move__amount">{{ line.amount | number:'1.2-2' }} €</span>
            <span class="ba-move__actions">
              <button type="button" class="ba-icon-btn" (click)="editLine(block, line)" title="Editar" aria-label="Editar movimiento">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" class="ba-icon-btn ba-icon-btn--danger" (click)="deleteLine(block, line)" title="Eliminar" aria-label="Eliminar movimiento">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" class="ba-more" *ngIf="block.count > maxLines" (click)="manage(block)">
            Ver los {{ block.count }} movimientos <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="ba-block__empty" *ngIf="!block.lines.length">Sin movimientos en el ejercicio</div>
      </div>
    </ng-container>
  </section>
</div>
